import { OPENING_COLORS } from '../../../lib/floorPlanOpening2D.js';

/**
 * @param {{ previewId: string; view?: '2d' | '3d' }} props
 */
function OpeningCatalogPreview({ previewId, view = '2d' }) {
  const isDoor = previewId.startsWith('door');
  const color = isDoor ? OPENING_COLORS.door : OPENING_COLORS.window;

  if (view === '3d') {
    return (
      <svg viewBox="0 0 48 64" aria-hidden className="floor-plan-workspace-library-preview-svg">
        <rect x="8" y="4" width="32" height="56" rx="2" fill="#f8fafc" stroke="#cbd5e1" strokeWidth="2" />
        <rect x="12" y="8" width="24" height="48" rx="1" fill={color} opacity="0.85" />
        <rect x="12" y="8" width="24" height="48" rx="1" fill="none" stroke="#334155" strokeWidth="1.5" />
      </svg>
    );
  }

  if (isDoor) {
    return (
      <svg viewBox="0 0 48 64" aria-hidden className="floor-plan-workspace-library-preview-svg">
        <rect x="10" y="6" width="28" height="52" fill={color} opacity="0.35" stroke={color} strokeWidth="2" />
        <path d="M10 58 A28 28 0 0 1 38 58" fill="none" stroke={color} strokeWidth="2" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 48 48" aria-hidden className="floor-plan-workspace-library-preview-svg">
      <rect x="8" y="12" width="32" height="28" fill={color} opacity="0.35" stroke={color} strokeWidth="2" />
      <line x1="24" y1="12" x2="24" y2="40" stroke={color} strokeWidth="2" />
      <line x1="8" y1="26" x2="40" y2="26" stroke={color} strokeWidth="2" />
    </svg>
  );
}

export default OpeningCatalogPreview;
